import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import api from '../api/api';

const DashboardPromoCode = () => {
  const [promoData, setPromoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPromoCode = async () => {
      try {
        const response = await api.get('/promo-codes/dashboard', {
          params: {
            is_dashboard: true,
          },
        });
        setPromoData(response.data);
        setLoading(false);
      } catch (error) {
        // Error fetching promo code
        setLoading(false);
      }
    };

    fetchPromoCode();
  }, []);

  if (loading || !promoData) return null;

  const getPromoText = () => {
    const { discount_type, discount_value } = promoData;
    return discount_type === 'percentage'
      ? `${discount_value}% off`
      : `${discount_value} off`;
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      className="bg-gradient-to-r from-secondary to-light text-tblue mb-4 sm:mb-0 p-4 sm:p-6 rounded-lg shadow-lg flex items-center gap-4 sm:gap-6"
    >
      {/* Promotion Icon */}
      <div className="hidden sm:flex items-center justify-center">
        <FontAwesomeIcon icon={faGift} className="text-3xl sm:text-4xl" />
      </div>

      {/* Promotion Content */}
      <div className="text-center sm:text-left flex-1">
        <h3 className="text-sm sm:text-lg font-bold mb-1">
          Limited Offer! Get {getPromoText()} on your first service! 🎉
        </h3>
        <p className="text-xs sm:text-sm">
          Use code <strong>{promoData.code}</strong> at checkout. {promoData.description}
        </p>
      </div>
    </motion.div>
  );
};

export default DashboardPromoCode;